import PropTypes from 'prop-types';

import {Icon, stringUtils} from 'front-onceforall-core';
import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';

import {planPropTypes} from '../../../../utils/propTypes';

function DetailsFeatures({plan, isOpen, maxDefaultFeatures}) {
  if (isEmpty(plan.features)) {
    return null;
  }

  const renderFeature = (feature, index) => {
    if (!isOpen && index >= maxDefaultFeatures) {
      return null;
    }

    const translatedValue = stringUtils.getStrongs(feature.translatedLabel);

    return (
      <div
        key={`feature-${plan.externalId}-${feature.id}`}
        className="mb-5 col-12 font-size-xs inline-container"
      >
        <Icon
          icon="check"
          size={12}
        />
        <span>{translatedValue}</span>
      </div>
    );
  };

  return (<>
    {plan.features.map(renderFeature)}
  </>);
}

DetailsFeatures.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  plan: planPropTypes().isRequired,
  maxDefaultFeatures: PropTypes.number.isRequired
};

export default DetailsFeatures;
